import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import GripperVertical from '@elliemae/ds-icons/GripperVertical';
import { appendHeaderFormatter, mergeClassNameToColumnHeader } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';

var DragHandle = SortableHandle(function () {
  return /*#__PURE__*/React.createElement(GripperVertical, {
    className: "drag-handle"
  });
});

var DndHeaderFormatter = function DndHeaderFormatter(value) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DragHandle, null), value);
};

var addDragAndDropToColumn = function addDragAndDropToColumn(grid, column) {
  column = appendHeaderFormatter(DndHeaderFormatter, column);
  return mergeClassNameToColumnHeader('with-dnd-column', column);
};

export { addDragAndDropToColumn };
//# sourceMappingURL=decorateGridWithDndColumns.js.map
